import { flow, applySnapshot, getParent } from 'mobx-state-tree';
import pick from 'lodash/pick';
import api from '~/api';
import { getIdentifier } from '~/mst/utils';
import type { IUsersModel } from '~/mst/models/users/model';
import { IUserModel } from './model';

export default (self: IUserModel) => ({
  fetch: flow(function* fetch() {
    try {
      self.startFetching();
      const { data } = yield api.users.read(self.id);
      applySnapshot(self, data);
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  }),
  update: flow(function* update(form) {
    self.startSyncing();
    const fields = ['first_name', 'last_name', 'phone_number', 'timezone', 'picture', 'locale', 'temp_units', 'job_title'];
    try {
      const payload = pick(form, fields);
      const { data } = yield api.users.update(self.id, payload);
      applySnapshot(self, data);
      self.finishSyncing();
    } catch (error) {
      self.failSyncing(error);
    }
  }),
  updatePermission: flow(function* updatePermission(externalId: string, payload: { role: string }) {
    self.startSyncing();
    try {
      yield api.users.updatePermission(self.id, externalId, payload);
      self.finishSyncing();
    } catch (error) {
      self.failSyncing(error);
      throw error;
    }
  }),
  deletePermission: flow(function* deletePermission(externalId: string) {
    self.startSyncing();
    try {
      yield api.users.deletePermission(self.id, externalId);
      self.finishSyncing();
    } catch (error) {
      self.failSyncing(error);
      throw error;
    }
  }),
  destroy: flow(function* destroy() {
    self.startSyncing();
    try {
      yield api.users.destroy(getIdentifier(self)!);
      const users = getParent<IUsersModel>(self, 2);
      users.remove(self);
    } catch (error) {
      self.failSyncing(error);
      throw error;
    }
  })
});
